import { RollerSkatingOutlined } from "@mui/icons-material";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authServies } from "../../services/authServices";
import { checkConfirmedPassword } from "../Dev/devSlice";
import { openErrorSnack, openSnackBar } from "../modals/snackBarSlice";

const initialState = {
  developers: [],
  developer: {},
  pending: false,
  error: {},
  success: false,
};

export const getDevelopers = createAsyncThunk(
  "/developers/getDevelopers",
  async (params = null, { dispatch }) => {
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.get(`/api/developers`);
      console.log(response);
      return response.data.data;
    } catch (error) {
      if (error.response.status === 500) {
        dispatch(
          openErrorSnack({ message: "Server Error please contact Developer " })
        );
      }

      if (error.response.data.status === 403) {
        dispatch(
          openErrorSnack({
            message: error.response?.data?.message,
          })
        );
        console.log(error.response);

        return error.response.data;
      }

      return error.response;
    }
  }
);

export const getDeveloper = createAsyncThunk(
  "/develoeprs/getDeveloper",
  async (log, { dispatch }) => {
    console.log(log);
    try {
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.get(`/api/developers/${log}`);
      console.log(response);
      return response.data.data;
    } catch (error) {
      if (error.response.status === 500) {
        dispatch(
          openErrorSnack({ message: "Server Error please contact Developer " })
        );
      }

      if (error.response.status === 404) {
        dispatch(openErrorSnack({ message: "Developer Not Found" }));
        return error.response.status === 404;
      }

      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: "you are not allowed to perform this request",
          })
        );
      }
      return error.response;
    }
  }
);

export const getDeveloperProject = createAsyncThunk(
  "/developers/getDeveloperProject",
  async (log, { dispatch }) => {
    try {
      console.log(log);
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.get(
        `/api/developers/projects/${log}`
      );
      console.log(response);
      return response.data.data;
    } catch (error) {
      if (error.response.status === 500) {
        dispatch(
          openErrorSnack({ message: "Server Error please contact Developer " })
        );
      }

      if (error.response.status === 404) {
        dispatch(openErrorSnack({ message: "Developer Not Found" }));
      }

      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: "you are not allowed to perform this request",
          })
        );
      }
      return error.response;
    }
  }
);

export const contactDeveloper = createAsyncThunk(
  "/developers/contactDeveloper",
  async (logs, { dispatch }) => {
    try {
      console.log(logs);
      await authServies.http.get("/sanctum/csrf-cookie");
      const response = await authServies.http.post(
        `/api/developers/contact/`,
        logs
      );
      dispatch(openSnackBar({ message: "contact sent successfully" }));
      console.log(response);
    } catch (error) {
      if (error.response.status === 500) {
        dispatch(
          openErrorSnack({
            message:
              "Server Error please check your network OR contact Developer ",
          })
        );
      }

      if (error.response.status === 404) {
        dispatch(openErrorSnack({ message: "Developer Not Found" }));
      }

      if (error.response.status === 403) {
        dispatch(
          openErrorSnack({
            message: "you are not allowed to perform this request",
          })
        );
      }
      return error.response;
    }
  }
);

const developerSlice = createSlice({
  name: "developerSlice",
  initialState,
  reducers: {},
  extraReducers: {
    [getDevelopers.pending]: (state, action) => {
      state.pending = true;

      const result = action.payload;
      console.log(result);
    },
    [getDevelopers.fulfilled]: (state, action) => {
      const result = action.payload;
      state.developers = result;

      if (result === 403) {
        state.error = result.message;
      }

      console.log(result);
      state.pending = false;
    },
    [getDevelopers.rejected]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      console.log(result);
    },
    [getDeveloper.pending]: (state, action) => {
      state.pending = true;

      const result = action.payload;
      console.log(result);
    },
    [getDeveloper.fulfilled]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      if (result === 404) {
        state.error = " Developer not found";
      }
      state.developer = result;
      console.log(result);
    },
    [getDeveloper.rejected]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      state.error = action.payload;
      console.log(result);
    },
    [getDeveloperProject.pending]: (state, action) => {
      state.pending = true;

      const result = action.payload;
      console.log(result);
    },
    [getDeveloperProject.fulfilled]: (state, action) => {
      state.pending = false;

      const result = action.payload;
      state.developer.projects = result;
      console.log(result);
    },
    [getDeveloperProject.rejected]: (state, action) => {
      const result = action.payload;
      state.error = action.payload;
      state.pending = false;
      console.log(result);
    },
    [contactDeveloper.pending]: (state, action) => {
      const result = action.payload;
      state.pending = true;
      console.log(result);
    },
    [contactDeveloper.fulfilled]: (state, action) => {
      const result = action.payload;
      state.success = true;
      state.pending = false;
      console.log(result);
    },
    [contactDeveloper.rejected]: (state, action) => {
      state.pending = false;
      const result = action.payload;
      state.success = false;
      console.log(result);
    },
  },
});

export default developerSlice.reducer;
